import { toRefs, computed, watch, reactive, onDeactivated, onUnmounted } from '@vue/composition-api'

// score change duration
const DURATION = 5000

// 比较比分变化，返回 1 是主队比分 up, -1 是客队 up
const compareScoreChange = (scores, oldScores) => {
  if (!scores || !oldScores) return 0
  if (Number(scores[0]) > Number(oldScores[0]) || scores[0] !== oldScores[0]) {
    // 主队
    return 1
  } else if (Number(scores[1]) > Number(oldScores[1] || scores[1] !== oldScores[1])) {
    // 客队
    return -1
  } else {
    // 无变化
    return 0
  }
}

export default function useMatchScore(props) {
  const { scoreOfWholeMatch, scoreOfSection, scoreInCurrentSection } = toRefs(props)
  // 比分变化状态：0 表示不变, 1 表示主队 up，-1 表示客队 up
  const scoreStatus = reactive({
    wholeScores: 0,
    sectionScores: 0,
    currentSectionScores: 0
  })

  // 总比分
  const wholeScores = computed(() => {
    if (!scoreOfWholeMatch.value) return [0, 0]
    return scoreOfWholeMatch.value.split(':')
  })

  // 节比分
  const sectionScores = computed(() => {
    if (!scoreOfSection.value) return
    let scores = scoreOfSection.value
    if (typeof scores === 'string') {
      scores = JSON.parse(scores)
    }
    return scores[scores.length - 1].split(':')
  })

  // 小节比分
  const currentSectionScores = computed(() => {
    if (!scoreInCurrentSection.value) return
    return scoreInCurrentSection.value.split(':')
  })

  // score 持续一段时间后消失
  const timerMap = {}
  const restoreScoreStatus = (key) => {
    clearTimeout(timerMap[key])
    timerMap[key] = setTimeout(() => {
      scoreStatus[key] = 0
    }, DURATION)
  }

  const clearTimers = () => {
    for (const key in timerMap) {
      timerMap[key] && clearTimeout(timerMap[key])
    }
  }

  onDeactivated(() => {
    clearTimers()
  })

  onUnmounted(() => {
    clearTimers()
  })

  watch(wholeScores, (val, oldVal) => {
    scoreStatus.wholeScores = compareScoreChange(val, oldVal)
    restoreScoreStatus('wholeScores')
  })

  if (sectionScores.value) {
    watch(sectionScores, (val, oldVal) => {
      scoreStatus.sectionScores = compareScoreChange(val, oldVal)
      restoreScoreStatus('sectionScores')
    })
  }

  if (currentSectionScores.value) {
    watch(currentSectionScores, (val, oldVal) => {
      scoreStatus.currentSectionScores = compareScoreChange(val, oldVal)
      restoreScoreStatus('currentSectionScores')
    })
  }

  return {
    scoreStatus,
    wholeScores,
    sectionScores,
    currentSectionScores
  }
}
